import { useOutletContext } from "react-router";

import type { DeviceTypeRecord } from "@/shared/domain/deviceTypes";

/** What the `/device-types/:deviceTypeId` layout hands each tab: the loaded type. */
export interface DeviceTypeContext {
  deviceType: DeviceTypeRecord;
}

/**
 * The device type the page shows, for a tab under `<DeviceType />`. Throws
 * outside that layout, where React Router has no outlet context to give.
 */
export function useDeviceTypeContext(): DeviceTypeContext {
  const context = useOutletContext<DeviceTypeContext | null | undefined>();
  if (!context) {
    throw new Error(
      "useDeviceTypeContext must be called inside a <DeviceType /> outlet",
    );
  }
  return context;
}
